import { render, staticRenderFns } from "./PoliceBookModal.vue?vue&type=template&id=ba98166a&scoped=true&"
import script from "./PoliceBookModal.vue?vue&type=script&lang=js&"
export * from "./PoliceBookModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba98166a",
  null
  
)

export default component.exports